import React, { useState, useEffect } from 'react';
import { fetchAllSessions } from '../../services/api';

const SessionFilters = ({ filters, onFilterChange }) => {
  const [locations, setLocations] = useState([]);
  const [monitors, setMonitors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch sessions to extract unique locations and monitors
    const fetchFiltersData = async () => {
      try {
        setLoading(true);
        const sessions = await fetchAllSessions();
        
        // Extract unique locations
        const uniqueLocations = [...new Set(sessions.map(session => session.location))];
        setLocations(uniqueLocations);
        
        // Extract unique launch monitors
        const uniqueMonitors = [...new Set(sessions.map(session => session.launchMonitor))];
        setMonitors(uniqueMonitors);
      } catch (error) {
        console.error('Error fetching filter data:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchFiltersData();
  }, []);

  const handleDateChange = (field, value) => {
    onFilterChange({
      dateRange: {
        ...filters.dateRange,
        [field]: value
      }
    });
  };

  const handleLocationChange = (e) => {
    const selectedLocations = Array.from(e.target.selectedOptions, option => option.value);
    onFilterChange({ locations: selectedLocations });
  };

  const handleMonitorChange = (e) => {
    const selectedMonitors = Array.from(e.target.selectedOptions, option => option.value);
    onFilterChange({ launchMonitors: selectedMonitors });
  };

  if (loading) {
    return <div className="filters-loading">Loading filters...</div>;
  }

  return (
    <div className="session-filters">
      <div className="filter-group">
        <label htmlFor="start-date">Start Date</label>
        <input
          type="date"
          id="start-date"
          value={filters.dateRange.start || ''}
          onChange={(e) => handleDateChange('start', e.target.value)}
        />
      </div>
      
      <div className="filter-group">
        <label htmlFor="end-date">End Date</label>
        <input
          type="date"
          id="end-date"
          value={filters.dateRange.end || ''}
          onChange={(e) => handleDateChange('end', e.target.value)}
        />
      </div>
      
      <div className="filter-group">
        <label htmlFor="locations">Locations</label>
        <select
          id="locations"
          multiple
          value={filters.locations}
          onChange={handleLocationChange}
        >
          {locations.map(location => (
            <option key={location} value={location}>{location}</option>
          ))}
        </select>
        <small>Hold Ctrl/Cmd to select multiple</small>
      </div>
      
      <div className="filter-group">
        <label htmlFor="monitors">Launch Monitors</label>
        <select
          id="monitors"
          multiple
          value={filters.launchMonitors}
          onChange={handleMonitorChange}
        >
          {monitors.map(monitor => (
            <option key={monitor} value={monitor}>{monitor}</option>
          ))}
        </select>
        <small>Hold Ctrl/Cmd to select multiple</small>
      </div>
    </div>
  );
};

export default SessionFilters;
